import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDSpAutoBetToken implements ICommand
{

	public Result : number = 0;
	public Token : string = "";

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.Result = ba.readUint8();
		this.Token = ba.readString();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint8(this.Result);
		ba.writeString(this.Token);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDSpAutoBetToken();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'Result(B)='+this.Result+' ';
		str += 'Token(S)='+this.Token+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 50085;
	}

	public getCmdName() : string
	{
		return 'SpAutoBetToken';
	}

}
